// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveOverride200Response
 */
export interface RemoveOverride200Response {
    /**
     * 
     */
    removed?: boolean;
}

/**
 * Check if a given object implements the RemoveOverride200Response interface.
 */
export function instanceOfRemoveOverride200Response(value: object): value is RemoveOverride200Response {
    return true;
}

export function RemoveOverride200ResponseFromJSON(json: any): RemoveOverride200Response {
    return RemoveOverride200ResponseFromJSONTyped(json, false);
}

export function RemoveOverride200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveOverride200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'removed': json['removed'] == null ? undefined : json['removed'],
    };
}

export function RemoveOverride200ResponseToJSON(json: any): RemoveOverride200Response {
    return RemoveOverride200ResponseToJSONTyped(json, false);
}

export function RemoveOverride200ResponseToJSONTyped(value?: RemoveOverride200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'removed': value['removed'],
    };
}

